// @ts-check
// Formatação e mensagens de erro compartilhadas pelas telas de assinatura, auditoria, privacidade e suporte.
import { ApiError, getErrorMessage } from '../../data/api-client.js';
import { hasTranslation, t } from '../../i18n/index.js';
import { enqueueSnackbar } from '../../ui/snackbar.js';

const CURRENCY_FORMATTER = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

/** @param {number} cents */
export const formatCents = (cents) => CURRENCY_FORMATTER.format(cents / 100);

/** @param {number | null | undefined} bytes */
export function formatByteSize(bytes) {
  if (!bytes) return '0 KB';
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}

/** Mensagem do erro: códigos desta frente primeiro, depois o catálogo geral. @param {unknown} error */
export function operationsErrorMessage(error) {
  if (error instanceof ApiError && hasTranslation(`operations.errors.${error.code}`)) {
    const detail = error.code === 'BILLING_PROVIDER_REJECTED' && error.messages[0] ? ` ${error.messages[0]}` : '';
    return `${t(`operations.errors.${error.code}`)}${detail}`;
  }
  return getErrorMessage(error);
}

/** Cor da etiqueta de situação da assinatura. @param {string} status */
export function subscriptionStatusColor(status) {
  return { TRIALING: 'blue', ACTIVE: 'green', PAST_DUE: 'orange', SUSPENDED: 'red', CANCELED: 'gray', LEGACY: 'gray' }[status] ?? 'gray';
}

/** @param {unknown} error */
export function showOperationsError(error) {
  const message = operationsErrorMessage(error);
  enqueueSnackbar({ message, variant: 'error', dedupeKey: message });
}
